import type { ComponentProps } from "react"
import { SelectValue as SelectValueBase } from "@/v2-ui/select/base/SelectBase"

export type SelectValueProps = ComponentProps<typeof SelectValueBase>

function SelectValue(props: SelectValueProps) {
  const { ...selectValueBaseProps } = props
  return <SelectValueBase {...selectValueBaseProps} />
}

export default SelectValue
